/**
 * Format file size in bytes to a human-readable format (e.g., "1.5 MB", "234 KB")
 * Uses binary units (1024) as standard for file sizes
 * @param bytes - File size in bytes
 * @returns Formatted file size string, or "Unknown" if null/undefined
 */
export const formatFileSize = (bytes: number | null | undefined): string => {
  if (bytes === null || bytes === undefined || bytes < 0) {
    return 'Invalid for this model';
  }

  if (bytes === 0) {
    return '0 B';
  }

  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  const size = bytes / Math.pow(1024, i);

  // Format with appropriate decimal places
  const formatted = i === 0 ? size.toString() : size.toFixed(1);

  return `${formatted} ${sizes[i]}`;
};

/**
 * Format storage quota from bytes to GB
 * Since storage quota is stored in the database as GB but converted to bytes in the API,
 * this function displays it in a user-friendly GB format
 * @param bytes - Storage quota in bytes (converted from GB)
 * @returns Formatted storage quota string (e.g., "100 GB")
 */
export const formatStorageQuota = (
  bytes: number | null | undefined
): string => {
  if (bytes === null || bytes === undefined || bytes <= 0) {
    return '0 GB';
  }

  // Convert bytes back to GB (1 GB = 1,073,741,824 bytes)
  const BYTES_PER_GB = 1073741824;
  const gb = Math.round(bytes / BYTES_PER_GB);
  return `${gb} GB`;
};
